import { attributesToProps } from 'html-react-parser';
import { Link } from '@/app_components/common/Link';
import { renderChild } from '@/app_lib/htmlParser/parsers/parserOptions';
import type { ParserProps } from '@/app_lib/htmlParser/types';

export const LinkParser = ({ domNode }: ParserProps) => {
  const { attribs, children } = domNode;
  const props = attributesToProps(attribs);
  const { href } = props;

  const isAffiliateLink =
    children.length && children[0].type === 'text' && children[0].data?.trim().toLowerCase() === 'view offer';
  const optimizelyTrackingData = isAffiliateLink
    ? {
        name: 'clicked_affiliate_link',
        // biome-ignore lint/style/useNamingConvention: From Optimizely - this is the pattern
        properties: { To: href?.toString() || '' },
      }
    : {
        name: 'body_link_clicks',
        // biome-ignore lint/style/useNamingConvention: From Optimizely - this is the pattern
        properties: { To: href?.toString() || '' },
      };

  return (
    <Link
      href={href?.toString() || ''}
      optimizelyTrackingData={optimizelyTrackingData}
      // TODO: Should we add prefetching for our links? There could be many links in the body so maybe not
      prefetch={false}
      {...props}
    >
      {renderChild(children)}
    </Link>
  );
};
